<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ fullName }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      <span v-if="contact.primary_phone_number">
        {{ contact.primary_phone_number.number }}
      </span>
    </td>
  </tr>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      if (typeof this.contact?.full_name === 'string') {
        return this.contact.full_name;
      }

      return `${this.contact?.first_name || ''} ${this.contact?.last_name || ''}`.trim();
    },
  },
};
</script>
